import { uiActionsFactory } from '../../../restux/ui/restuxUiActions.factory'
import { medicalEventFilesConfig } from './medicalEventFiles.model'

export const medicalEventFilesActions = uiActionsFactory(medicalEventFilesConfig).actions
